import React from "react";
import LegalPageLayout from "./LegalPageLayout";

const TermsAndConditions = () => {
  document.title = "AMANAT - Terms & Conditions";

  return (
    <LegalPageLayout>
      <div className="legal-doc-header">
        <p className="legal-doc-brand">AMANAT</p>
        <p className="legal-doc-company">
          Colca Services W.L.L — CR No. 178727-1 — Kingdom of Bahrain
        </p>
        <h1 className="legal-doc-title">TERMS AND CONDITIONS</h1>
        <p className="legal-doc-version">Version 2.0</p>
        <p className="legal-doc-dates">
          Effective Date: 01 July 2025 | Last Revised: 01 August 2026
        </p>
      </div>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Amanat&apos;s mobile application, website (
        <a
          href="https://www.amanatfintech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.amanatfintech.com
        </a>
        ), eCart (
        <a
          href="https://ecart.amanatfintech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          ecart.amanatfintech.com
        </a>
        ), or any of our services (collectively, the &quot;Services&quot;), you
        agree to be bound by these Terms and Conditions (&quot;T&amp;Cs&quot;). If
        you do not agree, please discontinue use of our Services immediately.
      </p>
      <p>
        These T&amp;Cs apply to all users, including customers, eCart buyers,
        course enrollees, and visitors. These T&amp;Cs are read together with our
        Privacy Policy and Refund Policy, both available at{" "}
        <a
          href="https://www.amanatfintech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.amanatfintech.com
        </a>
        .
      </p>

      <h2>2. Definitions</h2>
      <p>In these T&amp;Cs, the following terms have the meanings set out below:</p>
      <ul>
        <li>
          <strong>&quot;Amanat&quot; / &quot;we&quot; / &quot;us&quot; / &quot;our&quot;:</strong>{" "}
          Colca Services W.L.L, trading as Amanat, CR No. 178727-1, Kingdom of
          Bahrain.
        </li>
        <li>
          <strong>&quot;User&quot; / &quot;you&quot; / &quot;your&quot;:</strong> Any
          individual or entity accessing or using the Services.
        </li>
        <li>
          <strong>&quot;Services&quot;:</strong> All products and services offered by
          Amanat, including the mobile application, website, eCart, AI Training
          Courses, Micro-Insurance, Doorstep Remittances, Expense Tracking,
          Financial Well-being tools, and Micro-Investments.
        </li>
        <li>
          <strong>&quot;eCart&quot;:</strong> The online shopping portal at{" "}
          <a
            href="https://ecart.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            ecart.amanatfintech.com
          </a>
          .
        </li>
        <li>
          <strong>&quot;App&quot;:</strong> The Amanat – Financial Well-being mobile
          application available on iOS and Android.
        </li>
        <li>
          <strong>&quot;Website&quot;:</strong>{" "}
          <a
            href="https://www.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.amanatfintech.com
          </a>
          , including the eStore and all associated subdomains.
        </li>
      </ul>

      <h2>3. About Amanat</h2>
      <p>
        Amanat is Bahrain&apos;s first social impact fintech app, an end-to-end
        mobile financial platform, for planning and managing income, expenses,
        Doorstep Cash remittances, and micro insurance products – all in one place.
        Amanat empowers you to take full control of your finances. The app platform
        is operated by Colca Services W.L.L, a company incorporated and registered
        in the Kingdom of Bahrain under CR No. 178727-1, with its registered office
        at 302, 3rd Floor, Bahrain Fintech Bay, Arcapita Building 551, Road 4612,
        Block 346, Manama, Kingdom of Bahrain.
      </p>
      <p>
        Amanat operates under applicable approval and registrations issued by the
        relevant authorities of the Kingdom of Bahrain, including the Ministry of
        Industry, Commerce and Tourism (MOICT) under Activity 4791.
      </p>

      <h2>4. Eligibility</h2>
      <p>Our Services are available to individuals who:</p>
      <ul>
        <li>
          Are aged 18 years or above (the age of majority under the Bahrain Civil
          Code, Legislative Decree No. 19/2001);
        </li>
        <li>Have the legal capacity to enter into a binding contract;</li>
        <li>
          Are not prohibited from using financial services under applicable Bahrain
          law, including any sanctions, AML/CFT, or financial crime restrictions;
        </li>
        <li>
          Provide accurate, current, and complete information during registration
          and throughout their use of the Services.
        </li>
      </ul>
      <p>
        By using our Services, you represent and warrant that you meet all
        eligibility requirements. Amanat reserves the right to terminate access where
        eligibility requirements are not met.
      </p>

      <h2>5. Services</h2>
      <p>
        Amanat offers the following services through its mobile application and
        eStore:
      </p>
      <ul>
        <li>
          <strong>AI Training Courses:</strong> Digital content available for
          purchase on the eStore.
        </li>
        <li>
          <strong>Micro-Insurance:</strong> Insurance products distributed by Amanat
          as an agent of licensed insurance underwriters. (Amanat acts as Appointed
          Representative)
        </li>
        <li>
          <strong>Doorstep Cash Remittances:</strong> International money transfer
          with doorstep cash delivery to India and Nepal.
        </li>
        <li>
          <strong>Expense Tracking:</strong> A free in-app tool for tracking personal
          expenses.
        </li>
        <li>
          <strong>Financial Well-being:</strong> Free in-app financial health and
          literacy tools.
        </li>
        <li>
          <strong>Third-Party Products/Services:</strong> Third-Party Products &amp;
          Services offered on behalf of the partner company as per activity retail
          sales via Internet.
        </li>
        <li>
          <strong>Bill Payment:</strong> This service is not yet operational. Terms
          will be published before launch.
        </li>
      </ul>

      <h2>6. eCart &amp; Online Purchases</h2>
      <h3>6.1 Overview</h3>
      <p>
        Amanat operates an eCart at{" "}
        <a
          href="https://ecart.amanatfintech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          ecart.amanatfintech.com
        </a>{" "}
        offering digital products including AI Training Courses and other third-party
        products and services. By making a purchase on the eCart, you agree to these
        T&amp;Cs and our Refund Policy.
      </p>
      <h3>6.2 Order Process</h3>
      <p>
        Browse products → Add to cart → Proceed to checkout → Select payment method →
        Review and confirm order. An order confirmation email will be sent to your
        registered email address within 15 minutes of successful payment.
      </p>
      <h3>6.3 Payment Methods</h3>
      <p>We accept the following payment methods on the eStore:</p>
      <ul>
        <li>Visa (credit and debit cards)</li>
        <li>Mastercard (credit and debit cards)</li>
        <li>BenefitPay (Bahrain mobile payment network)</li>
      </ul>
      <p>
        All transactions are processed through PCI-DSS compliant payment gateways with
        SSL/TLS encryption. Amanat does not store your card number, CVV, or full card
        details.
      </p>
      <p>
        Cash on delivery is not available. All purchases must be completed using the
        secure online payment methods above.
      </p>
      <h3>6.4 Digital Delivery</h3>
      <p>
        Access to purchased digital products (AI Training Courses) is granted instantly
        upon receipt of payment confirmation. No physical delivery is made for digital
        products.
      </p>
      <h3>6.5 Refunds &amp; Returns</h3>
      <p>
        All purchases are subject to our Return &amp; Refund Policy available at{" "}
        <a
          href="https://www.amanatfintech.com/refund-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.amanatfintech.com/refund-policy
        </a>
        . In accordance with Bahrain Consumer Protection Law No. 35/2012, if a digital
        product is found to be defective or materially different from its description,
        you are entitled to a full refund regardless of access percentage or time
        elapsed since purchase.
      </p>
      <h3>6.6 Prices</h3>
      <p>
        All prices are displayed in Bahraini Dinars (BHD) and are inclusive of
        applicable taxes unless otherwise stated.
      </p>

      <h2>7. Micro-Insurance</h2>
      <h3>7.1 Role of Amanat</h3>
      <p>
        Amanat acts solely as a distribution agent for micro-insurance products. Amanat
        is NOT the insurer and does not underwrite insurance risk. Insurance products
        are underwritten by licensed insurance partners regulated by the Central Bank
        of Bahrain (CBB) Insurance Directorate.
      </p>
      <h3>7.2 Free-Look Period</h3>
      <p>
        In accordance with the Central Bank of Bahrain (CBB) Insurance Module and
        applicable Bahrain insurance regulations, you have a free-look period of fifteen
        (15) calendar days from the date of policy issuance to cancel your policy and
        receive a full premium refund, provided no claim has been made.
      </p>
      <h3>7.3 Claims</h3>
      <p>
        All insurance claims are handled directly by the licensed insurance underwriter
        identified in your policy document. Amanat is not liable for claims decisions.
        To escalate an insurance claim dispute, contact the CBB Consumer Protection Unit
        at{" "}
        <a href="https://www.cbb.gov.bh" target="_blank" rel="noopener noreferrer">
          www.cbb.gov.bh
        </a>
        .
      </p>
      <h3>7.4 Your Policy</h3>
      <p>
        The specific terms, coverage, exclusions, and conditions of your insurance are
        governed by the policy document issued by the underwriter, not solely by these
        T&amp;Cs.
      </p>

      <h2>8. Doorstep Cash Remittance Services</h2>
      <h3>8.1 Pre-Transaction Disclosure</h3>
      <p>
        Before you confirm any Doorstep Cash-remittance transaction, Amanat will
        display: (a) all Doorstep Cash delivery services fees and charges; (b) the
        services fees amount to be deducted from your account; and (d) the estimated
        delivery timeframe. You must confirm your acceptance of these terms before the
        services request is processed.
      </p>
      <h3>8.2 Processing Time</h3>
      <p>
        Doorstep cash delivery to India and Nepal is typically completed within 24–72
        hours of transaction confirmation. Delivery times may vary due to local
        holidays, third-party agent availability, or force majeure events.
      </p>
      <h3>8.3 Liability</h3>
      <p>
        Amanat accepts no liability for delays caused by the recipient country&apos;s
        local delivery agent, public holidays, or circumstances outside Amanat&apos;s
        reasonable control.
      </p>
      <h3>8.4 Refunds</h3>
      <p>
        Once a request of services is processed and delivered, it cannot be refunded. If
        a delivery fails or funds are not delivered, please contact{" "}
        <a href="mailto:support@amanatfintech.com">support@amanatfintech.com</a> within
        24 hours.
      </p>

      <h2>9. Prohibited Uses</h2>
      <p>
        You agree not to use the Services for any unlawful purpose or in any manner that
        violates these T&amp;Cs, including:
      </p>
      <ul>
        <li>
          Money laundering, terrorist financing, or any activity prohibited under Bahrain
          Law No. 4/2001 or CBB AML/CFT Module;
        </li>
        <li>Fraudulent transactions or identity theft;</li>
        <li>
          Unauthorised access to our systems or the accounts of other users;
        </li>
        <li>Transmitting malware, viruses, or harmful code;</li>
        <li>Violating any applicable Bahrain or international law.</li>
      </ul>

      <h2>10. Intellectual Property</h2>
      <p>
        All intellectual property rights in the Services, including the Amanat name,
        logo, app, website content, course materials, and software, are owned by or
        licensed to Colca Services W.L.L and are protected under:
      </p>
      <ul>
        <li>
          Bahrain Law No. 22/2006 (Copyright and Neighbouring Rights);
        </li>
        <li>
          Bahrain Law No. 1/2004 (Trademarks, Commercial Data and Trade Names);
        </li>
        <li>
          Bahrain Legislative Decree No. 1/2004 (Patents, Utility Models, and Industrial
          Designs).
        </li>
      </ul>
      <p>
        You may not reproduce, distribute, modify, or create derivative works from any
        Amanat content without our prior written consent.
      </p>

      <h2>11. Data Protection &amp; Privacy</h2>
      <p>
        Amanat processes your personal data in compliance with Bahrain Personal Data
        Protection Law (PDPL), Law No. 30 of 2018, and the CBB AML/CFT Module.
      </p>
      <p>
        You have the following rights regarding your personal data: right of access,
        right to correction, right to erasure, right to object, right to restrict
        processing, right to data portability, right to withdraw consent, and right to
        lodge a complaint.
      </p>
      <p>
        For all data protection queries and requests:{" "}
        <a href="mailto:privacy@amanatfintech.com">privacy@amanatfintech.com</a>{" "}
        (Subject: &quot;Data Subject Request&quot;). For our full Privacy Policy:{" "}
        <a
          href="https://www.amanatfintech.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.amanatfintech.com/privacy-policy
        </a>
        .
      </p>

      <h2>12. Complaint Handling</h2>
      <h3>12.1 First Contact</h3>
      <p>
        Contact our support team at{" "}
        <a href="mailto:support@amanatfintech.com">support@amanatfintech.com</a> or call{" "}
        <a href="tel:+97336961804">+973 3696 1804</a>. We will acknowledge your
        complaint within 2 business days and aim to resolve it within 5 business days.
      </p>
      <h3>12.2 Escalation</h3>
      <p>
        If your complaint is not resolved to your satisfaction, you may escalate to:
      </p>
      <ul>
        <li>
          Central Bank of Bahrain (CBB) Consumer Protection Unit:{" "}
          <a href="https://www.cbb.gov.bh" target="_blank" rel="noopener noreferrer">
            www.cbb.gov.bh
          </a>{" "}
          |{" "}
          <a
            href="https://complaints.cbb.gov.bh"
            target="_blank"
            rel="noopener noreferrer"
          >
            complaints.cbb.gov.bh
          </a>
        </li>
        <li>
          MOICT eCommerce Division:{" "}
          <a href="mailto:ecommerce@moic.gov.bh">ecommerce@moic.gov.bh</a> | Tel:{" "}
          <a href="tel:17359008">17359008</a>
        </li>
        <li>
          MOICT Consumer Protection Directorate: Tel:{" "}
          <a href="tel:17574969">17574969</a>
        </li>
        <li>
          Personal Data Protection Authority (for PDPL complaints): Ministry of Justice,
          Islamic Affairs and Waqf, Kingdom of Bahrain
        </li>
      </ul>

      <h2>13. Consumer Rights</h2>
      <p>
        These T&amp;Cs do not limit any rights you have under Bahrain Consumer
        Protection Law No. 35/2012, including the right to return defective goods or
        products that do not conform to their description and the right to a replacement
        or full refund at no cost to you. Any clause in these T&amp;Cs that purports to
        limit or exclude statutory consumer rights is void to the extent of such
        inconsistency.
      </p>

      <h2>14. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by applicable law, Amanat&apos;s total liability
        to you for any claim arising from these T&amp;Cs or your use of the Services
        shall not exceed the amount paid by you to Amanat in the three (3) months
        preceding the claim.
      </p>
      <p>
        Amanat is not liable for: indirect, consequential, incidental, or special
        damages; loss of profits or revenue; data loss; or any damages arising from
        third-party actions (including payment processors, insurance underwriters, or
        delivery agents).
      </p>
      <p>
        Nothing in these T&amp;Cs excludes liability for fraud, death, or personal injury
        caused by Amanat&apos;s negligence, or any other liability that cannot be
        excluded by Bahrain law.
      </p>

      <h2>15. Force Majeure</h2>
      <p>
        Amanat shall not be liable for any delay or failure in performance resulting from
        causes beyond its reasonable control, including acts of God, natural disasters,
        government actions, CBB directives, cyberattacks, power failures,
        telecommunications failures, pandemics, or any other extraordinary event.
      </p>

      <h2>16. Termination</h2>
      <p>
        Amanat reserves the right to suspend or terminate your account and access to the
        Services, with or without notice, if you breach these T&amp;Cs, if required by
        applicable law or regulatory directive, or if we reasonably suspect fraudulent,
        illegal, or harmful activity.
      </p>

      <h2>17. Changes to These T&amp;Cs</h2>
      <p>
        Amanat reserves the right to update these T&amp;Cs at any time. Material changes
        will be communicated by: (a) posting updated T&amp;Cs on our website with a new
        &quot;Last Revised&quot; date; (b) sending an in-app notification or email alert.
        Your continued use of the Services after the effective date of any update
        constitutes your acceptance of the revised T&amp;Cs.
      </p>

      <h2>18. Governing Law and Jurisdiction</h2>
      <p>
        These T&amp;Cs are governed by and construed in accordance with the laws of the
        Kingdom of Bahrain, including the Bahrain Civil Code, CBB Rulebook, PDPL 2018,
        and Consumer Protection Law No. 35/2012.
      </p>
      <p>
        Any dispute arising from or in connection with these T&amp;Cs shall be subject to
        the exclusive jurisdiction of the competent courts of the Kingdom of Bahrain.
      </p>

      <h2>19. Severability</h2>
      <p>
        If any provision of these T&amp;Cs is found to be invalid, unlawful, or
        unenforceable, that provision shall be modified to the minimum extent necessary
        to make it valid, and the remaining provisions shall continue in full force and
        effect.
      </p>

      <h2>20. Bilingual Clause / بند ثنائي اللغة</h2>
      <p>
        These Terms and Conditions are prepared in both English and Arabic. In the event
        of any inconsistency or conflict between the English and Arabic versions, the
        Arabic version shall prevail in accordance with the laws of the Kingdom of
        Bahrain.
      </p>
      <p dir="rtl" className="legal-rtl">
        تم إعداد هذه الشروط والأحكام باللغتين الإنجليزية والعربية. وفي حالة أي تناقض أو
        تعارض بين النسختين الإنجليزية والعربية، تسود النسخة العربية وفقاً لقوانين مملكة
        البحرين.
      </p>

      <hr className="legal-divider" />

      <div className="legal-rtl">
        <div className="legal-doc-header">
          <p className="legal-doc-brand">أمانات</p>
          <p className="legal-doc-company">
            شركة كولكا سيرفيسز ذ.م.م — سجل تجاري رقم 178727-1 — مملكة البحرين
          </p>
          <h1 className="legal-doc-title">الشروط والأحكام</h1>
          <p className="legal-doc-version">الإصدار 2.0</p>
          <p className="legal-doc-dates">
            تاريخ السريان: 01 يوليو 2025 | تاريخ آخر مراجعة: 1 أغسطس 2026
          </p>
        </div>

        <h2>1. قبول الشروط</h2>
        <p>
          بدخولك إلى تطبيق أمانات للهواتف المحمولة، أو الموقع الإلكتروني (
          <a
            href="https://www.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.amanatfintech.com
          </a>
          )، أو المتجر الإلكتروني (
          <a
            href="https://ecart.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            ecart.amanatfintech.com
          </a>
          )، أو أي من خدماتنا (يُشار إليها مجتمعةً بـ &quot;الخدمات&quot;)، أو استخدامك
          لها، فإنك توافق على الالتزام بهذه الشروط والأحكام (&quot;الشروط
          والأحكام&quot;). وإذا كنت لا توافق عليها، فيُرجى التوقف عن استخدام خدماتنا
          فوراً.
        </p>
        <p>
          تسري هذه الشروط والأحكام على جميع المستخدمين، بمن فيهم العملاء ومشترو المتجر
          الإلكتروني والمسجَّلون في الدورات والزوار. وتُقرأ هذه الشروط والأحكام جنباً إلى
          جنب مع سياسة الخصوصية وسياسة الاسترداد الخاصتين بنا، وكلتاهما متاحة على{" "}
          <a
            href="https://www.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.amanatfintech.com
          </a>
          .
        </p>

        <h2>2. التعريفات</h2>
        <p>
          في هذه الشروط والأحكام، يكون للمصطلحات التالية المعاني المبيَّنة أدناه:
        </p>
        <ul>
          <li>
            <strong>&quot;أمانات&quot; / &quot;نحن&quot; / &quot;لنا&quot; / &quot;الخاص بنا&quot;:</strong>{" "}
            شركة كولكا سيرفيسز ذ.م.م، والمتاجرة تحت اسم أمانات، سجل تجاري رقم 178727-1،
            مملكة البحرين.
          </li>
          <li>
            <strong>&quot;المستخدم&quot; / &quot;أنت&quot; / &quot;الخاص بك&quot;:</strong>{" "}
            أي فرد أو كيان يدخل إلى الخدمات أو يستخدمها.
          </li>
          <li>
            <strong>&quot;الخدمات&quot;:</strong> جميع المنتجات والخدمات التي تقدِّمها
            أمانات، بما في ذلك تطبيق الهاتف المحمول، والموقع الإلكتروني، والمتجر
            الإلكتروني، ودورات التدريب على الذكاء الاصطناعي، والتأمين متناهي الصغر،
            وخدمة توصيل الحوالات إلى المنزل، وتتبع المصروفات، وأدوات الرفاه المالي،
            والاستثمارات متناهية الصغر.
          </li>
          <li>
            <strong>&quot;المتجر الإلكتروني&quot;:</strong> بوابة التسوق الإلكتروني على{" "}
            <a
              href="https://ecart.amanatfintech.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ecart.amanatfintech.com
            </a>
            .
          </li>
          <li>
            <strong>&quot;التطبيق&quot;:</strong> تطبيق أمانات — الرفاه المالي للهواتف
            المحمولة، المتاح على نظامي iOS وAndroid.
          </li>
          <li>
            <strong>&quot;الموقع الإلكتروني&quot;:</strong>{" "}
            <a
              href="https://www.amanatfintech.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.amanatfintech.com
            </a>
            ، بما في ذلك المتجر الإلكتروني وجميع النطاقات الفرعية المرتبطة به.
          </li>
        </ul>

        <h2>3. نبذة عن أمانات</h2>
        <p>
          أمانات هو أول تطبيق للتكنولوجيا المالية ذات الأثر الاجتماعي في البحرين، وهو
          منصة مالية متكاملة عبر الهاتف المحمول لتخطيط وإدارة الدخل والمصروفات وتوصيل
          الحوالات النقدية إلى المنزل ومنتجات التأمين متناهي الصغر — كل ذلك في مكان
          واحد. ويمكِّنك أمانات من السيطرة الكاملة على شؤونك المالية. ومنصة التطبيق
          تُشغِّلها شركة كولكا سيرفيسز ذ.م.م، وهي شركة مؤسَّسة ومسجَّلة في مملكة البحرين
          تحت السجل التجاري رقم 178727-1، ويقع مقرها المسجَّل في 302، الطابق الثالث،
          خليج البحرين للتكنولوجيا المالية، مبنى أركابيتا 551، طريق 4612، مجمع 346،
          المنامة، مملكة البحرين.
        </p>
        <p>
          وتعمل أمانات بموجب الموافقات والتسجيلات المعمول بها الصادرة عن الجهات المختصة
          في مملكة البحرين، بما في ذلك وزارة الصناعة والتجارة والسياحة (MOICT) تحت
          النشاط رقم 4791.
        </p>

        <h2>4. الأهلية</h2>
        <p>خدماتنا متاحة للأفراد الذين:</p>
        <ul>
          <li>
            يبلغون من العمر 18 عاماً أو أكثر (سن الرشد بموجب القانون المدني البحريني،
            المرسوم بقانون رقم 19/2001)؛
          </li>
          <li>يتمتعون بالأهلية القانونية لإبرام عقد مُلزم؛</li>
          <li>
            غير محظور عليهم استخدام الخدمات المالية بموجب القانون البحريني المعمول به،
            بما في ذلك أية قيود تتعلق بالعقوبات أو مكافحة غسل الأموال وتمويل الإرهاب أو
            الجرائم المالية؛
          </li>
          <li>
            يقدِّمون معلومات دقيقة وحديثة وكاملة أثناء التسجيل وطوال فترة استخدامهم
            للخدمات.
          </li>
        </ul>
        <p>
          وباستخدامك لخدماتنا، فإنك تُقر وتضمن أنك تستوفي جميع متطلبات الأهلية. وتحتفظ
          أمانات بالحق في إنهاء الوصول حيثما لا تُستوفى متطلبات الأهلية.
        </p>

        <h2>5. الخدمات</h2>
        <p>
          تقدِّم أمانات الخدمات التالية من خلال تطبيقها على الهاتف المحمول ومتجرها
          الإلكتروني:
        </p>
        <ul>
          <li>
            <strong>دورات التدريب على الذكاء الاصطناعي:</strong> محتوى رقمي متاح للشراء
            على المتجر الإلكتروني.
          </li>
          <li>
            <strong>التأمين متناهي الصغر:</strong> منتجات تأمينية تقوم أمانات بتوزيعها
            بصفتها وكيلاً عن شركات اكتتاب تأمين مرخَّصة. (تعمل أمانات بصفتها ممثلاً معيَّناً)
          </li>
          <li>
            <strong>توصيل الحوالات النقدية إلى المنزل:</strong> تحويل الأموال دولياً مع
            توصيل النقد إلى المنزل في الهند ونيبال.
          </li>
          <li>
            <strong>تتبع المصروفات:</strong> أداة مجانية داخل التطبيق لتتبع المصروفات
            الشخصية.
          </li>
          <li>
            <strong>الرفاه المالي:</strong> أدوات مجانية داخل التطبيق للصحة المالية
            والثقافة المالية.
          </li>
          <li>
            <strong>منتجات/خدمات الأطراف الثالثة:</strong> منتجات وخدمات أطراف ثالثة
            تُقدَّم نيابةً عن الشركة الشريكة وفقاً لنشاط البيع بالتجزئة عبر الإنترنت.
          </li>
          <li>
            <strong>سداد الفواتير:</strong> هذه الخدمة ليست قيد التشغيل بعد. وسيتم نشر
            الشروط الخاصة بها قبل إطلاقها.
          </li>
        </ul>

        <h2>6. المتجر الإلكتروني وعمليات الشراء عبر الإنترنت</h2>
        <h3>6.1 نظرة عامة</h3>
        <p>
          تُشغِّل أمانات متجراً إلكترونياً على{" "}
          <a
            href="https://ecart.amanatfintech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            ecart.amanatfintech.com
          </a>{" "}
          يقدِّم منتجات رقمية تشمل دورات التدريب على الذكاء الاصطناعي وغيرها من منتجات
          وخدمات الأطراف الثالثة. وبإجرائك عملية شراء على المتجر الإلكتروني، فإنك توافق
          على هذه الشروط والأحكام وعلى سياسة الاسترداد الخاصة بنا.
        </p>
        <h3>6.2 عملية الطلب</h3>
        <p>
          تصفَّح المنتجات، ثم أضفها إلى السلة، ثم انتقل إلى صفحة الدفع، ثم اختر وسيلة
          الدفع، ثم راجع الطلب وأكِّده. وسيتم إرسال بريد إلكتروني لتأكيد الطلب إلى عنوان
          بريدك الإلكتروني المسجَّل خلال 15 دقيقة من إتمام الدفع بنجاح.
        </p>
        <h3>6.3 وسائل الدفع</h3>
        <p>نقبل وسائل الدفع التالية على المتجر الإلكتروني:</p>
        <ul>
          <li>فيزا (بطاقات الائتمان والخصم)</li>
          <li>ماستركارد (بطاقات الائتمان والخصم)</li>
          <li>بنفت باي (شبكة الدفع عبر الهاتف المحمول في البحرين)</li>
        </ul>
        <p>
          وتتم معالجة جميع المعاملات من خلال بوابات دفع ملتزمة بمعيار PCI-DSS مع تشفير
          SSL/TLS. ولا تحتفظ أمانات برقم بطاقتك أو رمز التحقق (CVV) أو تفاصيل البطاقة
          الكاملة.
        </p>
        <p>
          والدفع عند الاستلام غير متاح. ويجب إتمام جميع عمليات الشراء باستخدام وسائل
          الدفع الإلكتروني الآمنة المذكورة أعلاه.
        </p>
        <h3>6.4 التسليم الرقمي</h3>
        <p>
          يُمنح الوصول إلى المنتجات الرقمية المشتراة (دورات التدريب على الذكاء
          الاصطناعي) فوراً عند استلام تأكيد الدفع. ولا يتم إجراء أي تسليم مادي للمنتجات
          الرقمية.
        </p>
        <h3>6.5 الاسترداد والإرجاع</h3>
        <p>
          تخضع جميع عمليات الشراء لسياسة الإرجاع والاسترداد الخاصة بنا المتاحة على{" "}
          <a
            href="https://www.amanatfintech.com/refund-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.amanatfintech.com/refund-policy
          </a>
          . ووفقاً لقانون حماية المستهلك البحريني رقم 35/2012، إذا تبيَّن أن منتجاً رقمياً
          معيباً أو مختلفاً اختلافاً جوهرياً عن وصفه، يحق لك استرداد كامل المبلغ بصرف النظر
          عن نسبة الوصول إليه أو المدة المنقضية منذ الشراء.
        </p>
        <h3>6.6 الأسعار</h3>
        <p>
          تُعرض جميع الأسعار بالدينار البحريني (BHD) وتشمل الضرائب المطبَّقة ما لم يُذكر
          خلاف ذلك.
        </p>

        <h2>7. التأمين متناهي الصغر</h2>
        <h3>7.1 دور أمانات</h3>
        <p>
          تعمل أمانات بصفتها وكيل توزيع فقط لمنتجات التأمين متناهي الصغر. وأمانات ليست
          شركة التأمين ولا تقوم بالاكتتاب في مخاطر التأمين. ويتم الاكتتاب في منتجات
          التأمين من قِبَل شركاء تأمين مرخَّصين وخاضعين لرقابة إدارة التأمين في مصرف البحرين
          المركزي (CBB).
        </p>
        <h3>7.2 فترة المراجعة المجانية</h3>
        <p>
          وفقاً لوحدة التأمين الصادرة عن مصرف البحرين المركزي (CBB) ولوائح التأمين
          البحرينية المعمول بها، تتمتع بفترة مراجعة مجانية مدتها خمسة عشر (15) يوماً
          تقويمياً من تاريخ إصدار الوثيقة لإلغاء وثيقتك واسترداد كامل القسط، شريطة عدم
          تقديم أية مطالبة.
        </p>
        <h3>7.3 المطالبات</h3>
        <p>
          تتم معالجة جميع مطالبات التأمين مباشرةً من قِبَل شركة الاكتتاب المرخَّصة المحدَّدة
          في وثيقة التأمين الخاصة بك. وأمانات غير مسؤولة عن القرارات المتعلقة بالمطالبات.
          ولتصعيد أي نزاع بشأن مطالبة تأمينية، يُرجى التواصل مع وحدة حماية المستهلك في
          مصرف البحرين المركزي على{" "}
          <a href="https://www.cbb.gov.bh" target="_blank" rel="noopener noreferrer">
            www.cbb.gov.bh
          </a>
          .
        </p>
        <h3>7.4 وثيقتك</h3>
        <p>
          تخضع الشروط والتغطية والاستثناءات والأحكام المحدَّدة الخاصة بتأمينك لوثيقة
          التأمين الصادرة عن شركة الاكتتاب، وليس لهذه الشروط والأحكام وحدها.
        </p>

        <h2>8. خدمات توصيل الحوالات النقدية إلى المنزل</h2>
        <h3>8.1 الإفصاح قبل المعاملة</h3>
        <p>
          قبل تأكيدك لأية معاملة تتعلق بتوصيل حوالة نقدية إلى المنزل، ستعرض أمانات: (أ)
          جميع رسوم وأتعاب خدمات توصيل النقد إلى المنزل؛ (ب) مبلغ رسوم الخدمات الذي سيتم
          خصمه من حسابك؛ و(د) الإطار الزمني التقديري للتسليم. ويجب عليك تأكيد قبولك لهذه
          الشروط قبل معالجة طلب الخدمات.
        </p>
        <h3>8.2 وقت المعالجة</h3>
        <p>
          يتم عادةً إتمام توصيل النقد إلى المنزل في الهند ونيبال خلال 24–72 ساعة من تأكيد
          المعاملة. وقد تختلف أوقات التسليم بسبب العطلات المحلية أو مدى توفُّر وكلاء
          الأطراف الثالثة أو أحداث القوة القاهرة.
        </p>
        <h3>8.3 المسؤولية</h3>
        <p>
          لا تتحمل أمانات أية مسؤولية عن التأخيرات الناجمة عن وكيل التوصيل المحلي في بلد
          المستلم، أو العطلات الرسمية، أو الظروف الخارجة عن سيطرة أمانات المعقولة.
        </p>
        <h3>8.4 الاسترداد</h3>
        <p>
          بمجرد معالجة طلب الخدمات وتسليمه، لا يمكن استرداده. وإذا فشل التسليم أو لم يتم
          تسليم الأموال، فيُرجى التواصل مع{" "}
          <a href="mailto:support@amanatfintech.com">support@amanatfintech.com</a> خلال
          24 ساعة.
        </p>

        <h2>9. الاستخدامات المحظورة</h2>
        <p>
          توافق على عدم استخدام الخدمات لأي غرض غير مشروع أو بأية طريقة تنتهك هذه الشروط
          والأحكام، بما في ذلك:
        </p>
        <ul>
          <li>
            غسل الأموال أو تمويل الإرهاب أو أي نشاط محظور بموجب قانون مملكة البحرين رقم
            4/2001 أو وحدة مكافحة غسل الأموال وتمويل الإرهاب الصادرة عن مصرف البحرين
            المركزي؛
          </li>
          <li>المعاملات الاحتيالية أو انتحال الهوية؛</li>
          <li>
            الوصول غير المصرَّح به إلى أنظمتنا أو إلى حسابات مستخدمين آخرين؛
          </li>
          <li>إرسال البرمجيات الخبيثة أو الفيروسات أو الأكواد الضارة؛</li>
          <li>انتهاك أي قانون بحريني أو دولي معمول به.</li>
        </ul>

        <h2>10. الملكية الفكرية</h2>
        <p>
          جميع حقوق الملكية الفكرية في الخدمات، بما في ذلك اسم أمانات وشعارها وتطبيقها
          ومحتوى موقعها الإلكتروني ومواد الدورات والبرمجيات، مملوكة لشركة كولكا سيرفيسز
          ذ.م.م أو مرخَّصة لها، وهي محمية بموجب:
        </p>
        <ul>
          <li>
            قانون مملكة البحرين رقم 22/2006 (حقوق المؤلف والحقوق المجاورة)؛
          </li>
          <li>
            قانون مملكة البحرين رقم 1/2004 (العلامات التجارية والبيانات التجارية والأسماء
            التجارية)؛
          </li>
          <li>
            المرسوم بقانون البحريني رقم 1/2004 (براءات الاختراع ونماذج المنفعة والتصاميم
            الصناعية).
          </li>
        </ul>
        <p>
          ولا يجوز لك إعادة إنتاج أي محتوى خاص بأمانات أو توزيعه أو تعديله أو إنشاء أعمال
          مشتقة منه دون الحصول على موافقتنا الكتابية المسبقة.
        </p>

        <h2>11. حماية البيانات والخصوصية</h2>
        <p>
          تقوم أمانات بمعالجة بياناتك الشخصية بما يتوافق مع قانون حماية البيانات الشخصية
          البحريني (PDPL)، القانون رقم 30 لسنة 2018، ووحدة مكافحة غسل الأموال وتمويل
          الإرهاب الصادرة عن مصرف البحرين المركزي.
        </p>
        <p>
          وتتمتع بالحقوق التالية فيما يتعلق ببياناتك الشخصية: الحق في الاطلاع، والحق في
          التصحيح، والحق في المحو، والحق في الاعتراض، والحق في تقييد المعالجة، والحق في
          نقل البيانات، والحق في سحب الموافقة، والحق في تقديم شكوى.
        </p>
        <p>
          لجميع الاستفسارات والطلبات المتعلقة بحماية البيانات:{" "}
          <a href="mailto:privacy@amanatfintech.com">privacy@amanatfintech.com</a>{" "}
          (الموضوع: &quot;طلب صاحب بيانات&quot;). وللاطلاع على سياسة الخصوصية الكاملة:{" "}
          <a
            href="https://www.amanatfintech.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.amanatfintech.com/privacy-policy
          </a>
          .
        </p>

        <h2>12. معالجة الشكاوى</h2>
        <h3>12.1 الاتصال الأول</h3>
        <p>
          تواصل مع فريق الدعم لدينا على{" "}
          <a href="mailto:support@amanatfintech.com">support@amanatfintech.com</a> أو
          اتصل على{" "}
          <a href="tel:+97336961804">+973 3696 1804</a>. وسنقوم بالإقرار باستلام شكواك
          خلال يومي عمل ونسعى إلى حلها خلال 5 أيام عمل.
        </p>
        <h3>12.2 التصعيد</h3>
        <p>وإذا لم تُحل شكواك على النحو الذي يرضيك، فيجوز لك تصعيدها إلى:</p>
        <ul>
          <li>
            وحدة حماية المستهلك في مصرف البحرين المركزي (CBB):{" "}
            <a href="https://www.cbb.gov.bh" target="_blank" rel="noopener noreferrer">
              www.cbb.gov.bh
            </a>{" "}
            |{" "}
            <a
              href="https://complaints.cbb.gov.bh"
              target="_blank"
              rel="noopener noreferrer"
            >
              complaints.cbb.gov.bh
            </a>
          </li>
          <li>
            إدارة التجارة الإلكترونية بوزارة الصناعة والتجارة والسياحة (MOICT):{" "}
            <a href="mailto:ecommerce@moic.gov.bh">ecommerce@moic.gov.bh</a> | هاتف:{" "}
            <a href="tel:17359008">17359008</a>
          </li>
          <li>
            إدارة حماية المستهلك بوزارة الصناعة والتجارة والسياحة (MOICT): هاتف:{" "}
            <a href="tel:17574969">17574969</a>
          </li>
          <li>
            هيئة حماية البيانات الشخصية (للشكاوى المتعلقة بقانون حماية البيانات الشخصية):
            وزارة العدل والشؤون الإسلامية والأوقاف، مملكة البحرين
          </li>
        </ul>

        <h2>13. حقوق المستهلك</h2>
        <p>
          لا تحدُّ هذه الشروط والأحكام من أية حقوق تتمتع بها بموجب قانون حماية المستهلك
          البحريني رقم 35/2012، بما في ذلك الحق في إرجاع السلع المعيبة أو المنتجات غير
          المطابقة لوصفها، والحق في الاستبدال أو استرداد كامل المبلغ دون أية تكلفة عليك.
          ويُعد باطلاً أي بند في هذه الشروط والأحكام يهدف إلى الحد من حقوق المستهلك المقرَّرة
          قانوناً أو استبعادها، وذلك بقدر هذا التعارض.
        </p>

        <h2>14. تحديد المسؤولية</h2>
        <p>
          إلى أقصى حد يسمح به القانون المعمول به، لن تتجاوز المسؤولية الإجمالية لأمانات
          تجاهك عن أية مطالبة تنشأ عن هذه الشروط والأحكام أو عن استخدامك للخدمات المبلغَ
          الذي دفعته إلى أمانات خلال الثلاثة (3) أشهر السابقة للمطالبة.
        </p>
        <p>
          وأمانات غير مسؤولة عن: الأضرار غير المباشرة أو التبعية أو العرضية أو الخاصة؛ أو
          فقدان الأرباح أو الإيرادات؛ أو فقدان البيانات؛ أو أية أضرار تنشأ عن تصرفات أطراف
          ثالثة (بما في ذلك جهات معالجة المدفوعات أو شركات اكتتاب التأمين أو وكلاء
          التوصيل).
        </p>
        <p>
          ولا يوجد في هذه الشروط والأحكام ما يستبعد المسؤولية عن الاحتيال أو الوفاة أو
          الإصابة الشخصية الناجمة عن إهمال أمانات، أو أية مسؤولية أخرى لا يمكن استبعادها
          بموجب القانون البحريني.
        </p>

        <h2>15. القوة القاهرة</h2>
        <p>
          لن تكون أمانات مسؤولة عن أي تأخير أو إخفاق في الأداء ناتج عن أسباب خارجة عن
          سيطرتها المعقولة، بما في ذلك القضاء والقدر، والكوارث الطبيعية، والإجراءات
          الحكومية، وتوجيهات مصرف البحرين المركزي، والهجمات السيبرانية، وانقطاع التيار
          الكهربائي، وأعطال الاتصالات، والأوبئة، أو أي حدث استثنائي آخر.
        </p>

        <h2>16. الإنهاء</h2>
        <p>
          تحتفظ أمانات بالحق في تعليق أو إنهاء حسابك ووصولك إلى الخدمات، بإشعار أو دون
          إشعار، في حال إخلالك بهذه الشروط والأحكام، أو إذا كان ذلك مطلوباً بموجب القانون
          المعمول به أو أي توجيه رقابي، أو إذا اشتبهنا بشكل معقول في وجود نشاط احتيالي أو
          غير مشروع أو ضار.
        </p>

        <h2>17. التعديلات على هذه الشروط والأحكام</h2>
        <p>
          تحتفظ أمانات بالحق في تحديث هذه الشروط والأحكام في أي وقت. وسيتم الإبلاغ عن
          التغييرات الجوهرية عن طريق: (أ) نشر شروط وأحكام محدَّثة على موقعنا الإلكتروني
          تحمل تاريخ &quot;آخر مراجعة&quot; جديداً؛ (ب) إرسال إشعار داخل التطبيق أو تنبيه
          بالبريد الإلكتروني. ويشكِّل استمرارك في استخدام الخدمات بعد تاريخ سريان أي تحديث
          قبولاً منك للشروط والأحكام المعدَّلة.
        </p>

        <h2>18. القانون الواجب التطبيق والاختصاص القضائي</h2>
        <p>
          تخضع هذه الشروط والأحكام وتُفسَّر وفقاً لقوانين مملكة البحرين، بما في ذلك القانون
          المدني البحريني، وكتاب قواعد مصرف البحرين المركزي، وقانون حماية البيانات الشخصية
          لسنة 2018، وقانون حماية المستهلك رقم 35/2012.
        </p>
        <p>
          ويخضع أي نزاع ينشأ عن هذه الشروط والأحكام أو يتصل بها للاختصاص القضائي الحصري
          للمحاكم المختصة في مملكة البحرين.
        </p>

        <h2>19. قابلية الفصل</h2>
        <p>
          إذا تبيَّن أن أي حكم من أحكام هذه الشروط والأحكام باطل أو غير مشروع أو غير قابل
          للتنفيذ، يتم تعديل ذلك الحكم إلى الحد الأدنى اللازم لجعله صحيحاً، وتظل الأحكام
          المتبقية سارية المفعول والأثر بالكامل.
        </p>

        <h2>20. بند ثنائي اللغة / BILINGUAL CLAUSE</h2>
        <p>
          تم إعداد هذه الشروط والأحكام باللغتين الإنجليزية والعربية. وفي حالة وجود أي
          تناقض أو تعارض بين النسختين الإنجليزية والعربية، تسود النسخة العربية وفقاً
          لقوانين مملكة البحرين.
        </p>
      </div>
    </LegalPageLayout>
  );
};

export default TermsAndConditions;
